import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import TextBanner from '../../components/TextBanner/TextBanner';
import CompanyLocation from '../../components/CompanyLocation/CompanyLocation';

const TestHome = () => {
    return (
        <div>
            <Navbar />
            <TextBanner />
            <CompanyLocation />
            
        </div>
    );
};

export default TestHome;